import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetCoupon } from "../redux/slices/GetCouponSlice";
import Footer from "../Fotter";
import axios from "axios";
import endPoint from "../redux/EndPoint/endpoint";

const Coupons = () => {
  const dispatch = useDispatch();
  const { GetCouponData } = useSelector((state) => state?.getCoupon);
  const [showModal, setShowModal] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [giftData, setGiftData] = useState("");
  const [showModalGift, setShowModalGift] = useState(false);

  useEffect(() => {
    dispatch(GetCoupon());
  }, [dispatch]);

  useEffect(() => {
    const _handleFreeGift = async () => {
      try {
        const res = await axios.get(endPoint.GetFreeGift);
        setGiftData(res?.data?.data);
      } catch (error) {
        console.error("Error fetching free gift data:", error);
      }
    };
    _handleFreeGift();
  }, []);

  const _handleClickCoupon = (coupon) => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedCoupon(null);
  };

  const closeModalGift = () => {
    setShowModalGift(false);
  };

  const handleButtonClick = (giftData) => {
    setShowModalGift(true);
  };

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-16647750621";
    script1.async = true;
    document.head.appendChild(script1);
    script1.onload = () => {
      const script2 = document.createElement("script");
      script2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-16647750621');
        `;
      document.head.appendChild(script2);
    };

    return () => {
      const scripts = document.querySelectorAll(
        'script[src="https://www.googletagmanager.com/gtag/js?id=AW-16647750621"]'
      );
      scripts.forEach((script) => script.remove());
    };
  }, []);

  return (
    <div className="bg-gray-100 min-h-screen ">
      <div className="p-6 sm:p-4 ">
        <div className="mx-auto max-w-7xl">
          <h2 className="text-3xl font-bold text-center mb-8 mt-12">
            Exclusive Coupons
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 sm:gap-6 md:gap-6 gap-2">
            {GetCouponData?.coupons && GetCouponData.coupons.length > 0 ? (
              GetCouponData.coupons.map((coupon) => (
                <div
                  key={coupon._id}
                  className="relative bg-white rounded-xl w-full"
                >
                  <div className="absolute top-0 right-0 bg-red-500 text-white px-3 py-1 text-sm font-semibold rounded-bl-xl">
                    {coupon.discount}
                    {coupon.discountType === "percentage" ? "%" : ""} OFF
                  </div>
                  <div
                    onClick={() => _handleClickCoupon(coupon)}
                    className="p-4"
                  >
                    <div className="flex items-center">
                      {coupon.image && coupon.image[0] && (
                        <img
                          src={coupon.image[0]}
                          alt={coupon.Title}
                          className="w-20 h-20 object-cover rounded-lg mr-4"
                        />
                      )}
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mt-6 line-clamp-1 mb-2">
                          {coupon.Title}
                        </h3>
                        <p className="text-gray-600 line-clamp-2">
                          {coupon.description}
                        </p>
                      </div>
                    </div>
                    <div className="mt-4">
                      <div className="flex items-center justify-between bg-gray-100 border border-gray-300 rounded-lg">
                        <span className="text-lg font-mono text-gray-800 w-[50%] truncate px-2 py-1 rounded-l-md">
                          {coupon.code}
                        </span>
                        {/* <button
                          onClick={() => copyCode(coupon.code)}
                          className="w-[45%] bg-blue-100 hover:bg-blue-400 text-black font-semibold py-2 px-1 rounded-lg transition duration-300 ease-in-out transform"
                        >
                          Copy Code
                        </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="flex items-center justify-center ">
                <p className="text-black text-center">Coupon not found</p>
              </div>
            )}
          </div>
          {giftData && (
            <>
              <h2 className="text-3xl font-bold text-center mb-8 mt-12">
                Claim Your Gift Now!
              </h2>
              <div className="grid">
                <div className="relative bg-white rounded-xl w-[80%] mx-auto">
                  <div className="p-4">
                    <div className="flex items-center">
                      {giftData.images && giftData.images[0] && (
                        <img
                          src={giftData.images[0]}
                          alt={giftData.title}
                          className="w-20 h-20 object-cover rounded-lg mr-4"
                        />
                      )}
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mt-6 line-clamp-1 mb-2">
                          {giftData.title}
                        </h3>
                        <p className="text-gray-600 line-clamp-2">
                          {giftData.description}
                        </p>
                      </div>
                    </div>
                    <div className="flex justify-center mt-2">
                      <button
                        onClick={() => handleButtonClick(giftData)}
                        className="bg-orange-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600 transition duration-300"
                      >
                        Claim Gift
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
          <div className="relative bg-white rounded-xl p-6 w-80 sm:w-96">
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-2xl font-bold"
            >
              ❌
            </button>

            <h3 className="text-xl font-semibold text-center mb-4">
              Redeem Offer Now!
            </h3>
            <p className="text-center mb-4">
              To redeem this offer, download the app now!
            </p>
            <div className="flex justify-center mb-4">
              <button
                onClick={() =>
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.bharatcod&hl=en",
                    "_blank"
                  )
                }
                className="bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-lg transition"
              >
                Download App
              </button>
            </div>
          </div>
        </div>
      )}

      {showModalGift && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
          <div className="relative bg-white rounded-xl p-6 w-80 sm:w-96">
            <button
              onClick={closeModalGift}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-2xl font-bold"
            >
              ❌
            </button>

            <h3 className="text-xl font-semibold text-center mb-2">
              Claim Your Gift!
            </h3>
            <p className="text-center mb-4">
              To Claim your gift kindly download the app !
            </p>
            <div className="flex justify-center mb-2">
              <button
                onClick={() =>
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.bharatcod&hl=en",
                    "_blank"
                  )
                }
                className="bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-lg transition"
              >
                Download App
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Coupons;
